<template>
  <v-container class="component_main px-6 py-0">
    <v-row>
      <v-col cols=12>
        <template v-if="[1, 46, 192].includes(grupoEconomico)">
        <h1>Relatório analítico de pagamentos</h1>
        <p>Solicite o relatório analítico de pagamentos.</p>
        </template>
        <template v-else>
        <h1>Relatórios de pagamentos</h1>
        <p>Solicite o relatório analítico (em nível de item) ou sintético (em nível de guia) de pagamentos.</p>
        </template>
      </v-col>
      <v-col cols=12>
       <RelatorioFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :updateFilter="(formData) => solicitaRelatorioConfirm(formData)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :validarForm="validarForm"
          :getOperadoras="(opts) => getOperadoras(opts)"
          :grupoEconomico="grupoEconomico"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import RelatorioFilter from "@/components/recebiveis/analitico_pagamentos/Filter";

export default {
  components: {
    RelatorioFilter
  },
  data() {
    return {
      chartId: "1",
      filter:{},
      prestadores: [],
      validarForm: false
    };
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    },
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeUpdate() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
  },
  mounted(){
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
    let opts = {
          grupo_economico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "recebiveis",
          prestador_ids: []
        }
    this.getOperadoras(opts)
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras",
    ]),
    
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    usaDate (date) {
        if (!date) return null
        const [year, day, month] = date.split('-')
        return `${year}-${day}-${month}`
    },
    solicitaRelatorioConfirm(filter) {
      const intervalo = 1000 * 60 * 60 * 24 * 365.25//1 ano
      if(this.filter.data_inicio == null &&
          this.filter.data_fim == null &&
          this.filter.data_recurso_inicio == null &&
          this.filter.data_recurso_fim == null &&
          this.filter.data_1a_publicacao_inicio == null &&
          this.filter.data_1a_publicacao_fim == null
      ){
              let paramModal = {
              type: "info",
              title: "Atenção:",
              message: "Selecione ao menos um período de tempo.",
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Cancelar", show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }

      
      this.filter = filter
      let prestador = this.filter.prestador_id.length?this.filter.prestador_id.map( prest => this.prestadores.find(p=>p.id == prest).prest_nome).join(', ')+'.' : 'Todos'
      let operadora = this.filter.operadora_ans_id.length?this.filter.operadora_ans_id.map( oper => this.listOperadora.find(p=>p.id == oper).oper_nome).join(', ')+'.' : 'Todos'
      let dataInicial = this.formatDate(this.filter.data_inicio)
      let dataFinal = this.formatDate(this.filter.data_fim)
      let dataRecursoInicial = this.formatDate(this.filter.data_recurso_inicio)
      let dataRecursoFinal = this.formatDate(this.filter.data_recurso_fim)
      let dataPublicacaoInicial = this.formatDate(this.filter.data_1a_publicacao_inicio)
      let dataPublicacaoFinal = this.formatDate(this.filter.data_1a_publicacao_fim)

      if (dataRecursoInicial != null && (new Date(this.filter.data_recurso_fim) - new Date(this.filter.data_recurso_inicio)) / intervalo > 1 ||
          dataPublicacaoInicial != null && (new Date(this.filter.data_1a_publicacao_fim) - new Date(this.filter.data_1a_publicacao_inicio)) / intervalo > 1 ||
          dataInicial != null && (new Date(this.filter.data_fim) - new Date(this.filter.data_inicio)) / intervalo > 1
      ){
              let paramModal = {
              type: "info",
              title: "Atenção:",
              message: "O período máximo de 1 ano foi excedido.",
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Cancelar", show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            return
      }

      let message = `
          Prestador(es): <strong>${prestador}</strong><br>
          Operadora(s): <strong>${operadora}</strong><br>`;

      if(this.filter.data_1a_publicacao_inicio || this.filter.data_1a_publicacao_fim){
        message +=  `Data de primeira publicação entre <strong>${dataPublicacaoInicial}</strong> e <strong>${dataPublicacaoFinal}</strong><br>`
      }
      if(this.filter.data_recurso_inicio || this.filter.data_recurso_fim){
        message +=  `Data de recurso entre <strong>${dataRecursoInicial}</strong> e <strong>${dataRecursoFinal}</strong><br>`
      }
      if(this.filter.data_inicio || this.filter.data_fim){
        message +=  `Data de pagamento entre <strong>${dataInicial}</strong> e <strong>${dataFinal}</strong><br>`
      }
            
      let paramModal = {
        type: "info",
        title: "Solicitar relatório " + filter.relatorio_sintetico? "sintético": "analítico" + " de pagamentos com o filtro:",
        message,
        callback: () => this.solicitaRelatorio(this.filter),
        btConfirm: { name: "Solicitar", show: true },
        btCancel: { name: "Cancelar", show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    solicitaRelatorio(formData) {
      let opts = {}
      if(formData == null){
        opts = Object.assign(this.pagination, { grupoEconomico: this.grupoEconomico, limitar: false }, this.filter)
        this.solicitaRelatorioConfirm(opts).then(()=>this.showList = true)
        return
      }
      formData.grupo_economico = this.grupoEconomico

      let acao = formData.relatorio_sintetico? "GetSinteticoPagamentos":"GetAnaliticoPagamentos";
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "recebiveis",
          "Acao": acao,
          "Payload": payload
        }]
      };
      
      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: response.warning? "warning":"success",
          title: "Atenção!",
          message: response.mensagem,
          callback: () => {},
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    validaForm(){
      this.validarForm = true
      this.$nextTick(()=>this.validarForm = false)
    }
  }
};
</script>
<style>
</style>